import { delegationConstants } from '../constants/delegation.constants';
import delegationService from '../services/delegation.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';
import { b64toBlob } from '../helpers/base64';

export const delegationActions = {
  create,
  update,
  remove,  
  fetch,  
  get,  
};

function create (obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const request = await delegationService.create(obj);
      dispatch(success(request));
      dispatch(alertActions.success('Delegação criada.'));
      history.push('/delegations');
    } catch(error) {            
      dispatch(alertActions.error(error));      
      dispatch(failure(error));      
    }
  };

  function request() { return { type: delegationConstants.CREATE_REQUEST } }
  function success(request) { return { type: delegationConstants.CREATE_SUCCESS, request } }
  function failure(error) { return { type: delegationConstants.CREATE_FAILURE, error } }
}

function update (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const request = await delegationService.update(id, obj);
      dispatch(success(request));
      dispatch(alertActions.success('Delegação alterada'));
      history.push('/delegations');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: delegationConstants.UPDATE_REQUEST } }
  function success(request) { return { type: delegationConstants.UPDATE_SUCCESS, request } }
  function failure(error) { return { type: delegationConstants.UPDATE_FAILURE, error } }
}

function remove (id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const request = await delegationService.remove(id);
      dispatch(success(request));
      dispatch(alertActions.success("Delegação removida"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: delegationConstants.REMOVE_REQUEST } }
  function success(request) { return { type: delegationConstants.REMOVE_SUCCESS, request } }
  function failure(error) { return { type: delegationConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());
    try {
      const delegations = await delegationService.fetch(params);
      
      if (params.export && delegations.file) {        
        const blob = b64toBlob(delegations.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'delegacoes-aprovacao.xlsx');
        tempLink.click();
      }
      dispatch(success(delegations));
    } catch(error) {      
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: delegationConstants.FETCH_REQUEST } }
  function success(delegations) { return { type: delegationConstants.FETCH_SUCCESS, delegations } }
  function failure(error) { return { type: delegationConstants.FETCH_FAILURE, error } }
}

function get (id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const delegation = await delegationService.get(id);
      dispatch(success(delegation));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: delegationConstants.GET_REQUEST } }
  function success(request) { return { type: delegationConstants.GET_SUCCESS, delegation } }
  function failure(error) { return { type: delegationConstants.GET_FAILURE, error } }
}
